/**
 * T12 (E8/Q6): lädt Produkte mit Kanalregel-Verletzungen für einen Channel
 * als Wizard-Vorbelegung. `GET /products/issues` (S8-Endpoint) kennt keinen
 * Channel-Filter — client-seitig gefiltert über `channels[]` je Produkt
 * (siehe Task-Bericht: einfachste korrekte Variante ohne neuen Backend-Code).
 * Bricht ab, sobald 50 Treffer erreicht sind oder keine weitere Seite folgt.
 */
import { useMutation } from '@tanstack/react-query'

import { getProductsWithIssues } from '@/lib/api/channel-readiness'

const PAGE_SIZE = 200
const MAX_PAGES = 5
const MAX_RESULTS = 50

async function fetchChannelIssueProductIds(channelId: string): Promise<string[]> {
  const matched: string[] = []
  for (let page = 1; page <= MAX_PAGES; page++) {
    const res = await getProductsWithIssues({ page, page_size: PAGE_SIZE })
    for (const product of res.products) {
      if (product.channels?.includes(channelId)) matched.push(product.product_id)
      if (matched.length >= MAX_RESULTS) break
    }
    if (matched.length >= MAX_RESULTS || res.products.length < PAGE_SIZE) break
  }
  return matched.slice(0, MAX_RESULTS)
}

export function useIssuesEntryProducts() {
  return useMutation({ mutationFn: fetchChannelIssueProductIds })
}
